import styled from 'styled-components';

import { breakpoints, SkeletonElement } from '@notino/react-styleguide-v20';

export const StyledReservationTitleSkeleton = styled(SkeletonElement)`
  margin: 2rem auto 1.5rem;
  height: 2rem;
  width: 12.375rem;

  @media (min-width: ${breakpoints.lg}) {
    height: 2.75rem;
  }
`;
